import { useAuth } from "@/provider/UserProvider";
import { generateKeySdk } from "@/services/sdk";
import { useState } from "react";
import { toast } from "react-toastify";

const useGenerate = () => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const { isLoginClient } = useAuth();

  const handleGenerate = async (callback: () => void) => {
    if (!isLoginClient) return toast.warning('Please login to continue!');
    if (!name) return toast.warning('Please enter name!');
    setLoading(true);

    try {
      const res = await generateKeySdk(name);
      if (res.data.id) {
        toast.success('Created API Key successfully!');
        callback();
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    handleGenerate,
    setName
  }
}

export default useGenerate;